import { Action } from 'redux';

export enum ActionTypes {
    LOAD_START = '@@checkoutsTerms/LOAD_START',
    LOAD_SUCCESS = '@@checkoutsTerms/LOAD_SUCCESS',
    LOAD_ERROR = '@@checkoutsTerms/LOAD_ERROR',
    
    UPDATE_START = '@@checkoutsTerms/UPDATE_START',
    UPDATE_SUCCESS = '@@checkoutsTerms/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@checkoutsTerms/UPDATE_ERROR',

    MODIFY_START = '@@checkoutsTerms/MODIFY_START',
    MODIFY_SUCCESS = '@@checkoutsTerms/MODIFY_SUCCESS',
    MODIFY_ERROR = '@@checkoutsTerms/MODIFY_ERROR',
}

export type CheckoutsTermsPayload = {
    terms: string;
    isDefault?: boolean;
}

export interface CheckoutsTermsLoadAction extends Action {
    type: ActionTypes.LOAD_START;
}
export interface CheckoutsTermsLoadSuccessAction extends Action {
    type: ActionTypes.LOAD_SUCCESS;
    payload: CheckoutsTermsPayload;
}
export interface CheckoutsTermsLoadErrorAction extends Action {
    type: ActionTypes.LOAD_ERROR;
}

export interface CheckoutsTermsUpdateAction extends Action {
    type: ActionTypes.UPDATE_START;
    payload: CheckoutsTermsPayload;
}
export interface CheckoutsTermsUpdateSuccessAction extends Action {
    type: ActionTypes.UPDATE_SUCCESS;
    payload: CheckoutsTermsPayload;
}
export interface CheckoutsTermsUpdateErrorAction extends Action {
    type: ActionTypes.UPDATE_ERROR;
}


export interface CheckoutsTermsModifySuccessAction extends Action {
    type: ActionTypes. MODIFY_SUCCESS;
    payload: CheckoutsTermsPayload;
}
export interface CheckoutsTermsModifyErrorAction extends Action {
    type: ActionTypes. MODIFY_ERROR;
}

export interface CheckoutsTermsState extends CheckoutsTermsPayload {
    isLoading?: boolean,
    isLoaded?: boolean,
    isError?: boolean,
}